var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.bindSuccess.visible)?_c('bang-ding-org',{ref:"bangDingOrgRef",on:{"on-success":_vm.onSuccess}}):_c('div',[_c('el-result',{attrs:{"icon":"success","title":"成功提示","subTitle":'绑定【' + _vm.bindSuccess.orgName +'】单位成功，请等待单位管理员审核。'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }